import { RouteRecordRaw } from 'vue-router';
import settingRouter from './settingRouter';

const casherRouters: Array<RouteRecordRaw> = [
  ...settingRouter,
];

export default casherRouters;
